<template>
    <v-app>
        <topnav />
        <div class="languages_page">

            <div class="languages_page_container">
                <h2 class="wellcome">
                    ¡Bienvenida Yolanda!
                </h2>
                <div class="question">
                    ¿Qué deseas hacer?
                </div>
            </div>
            
        </div>
        <footer-nav />
    </v-app>
</template>
<script>
import Topnav from '@/containers/navs/Topnav'
import Footer from '@/containers/navs/Footer'

export default {
    components: {
       topnav: Topnav,
       "footer-nav": Footer, 
    },
    data() {
        return {
            
        }
    },
    
}
</script>
<style lang="scss">
@import '../assets/styles/layout/languages';
</style>